<template>
  <transition name='fade'>
    <div class="modal login_box"
         v-if='visible'>
      <div class="login">
        <span class="iconfont el-icon-close"
              @click.stop='closeBox()'></span>
        <div class="login_company_title">
          <span>请选择登录单位</span>
        </div>
        <el-scrollbar class="company_list">
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="item.id"
                         v-for="item in companyList"
                         :key="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="login_button">
          <el-button type="primary">登录</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'logincompany',
  data() {
    return {
      visible: false,
      checkList: [],
      companyList: [{ id: '1', name: '公司1' }, { id: '2', name: '公司2' }, { id: '3', name: '公司3' }, { id: '4', name: '公司4' }, { id: '5', name: '公司5' }]
    }
  },
  mounted() {
    this.$root.eventHub.$on('loginCompanyModal', (type, data) => {
      this.visible = true
    })


  },
  destroyed() {
    this.$root.eventHub.$off('loginCompanyModal')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    }


  },
  watch: {
    checkList(val, oldval) {
      if (val.length > 1) {
        this.checkList = val.slice(-1);
      }
      if (!val.length) {
        this.checkList = oldval;
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.login_box
  .login
    position relative
    padding-top 58px
    width 380px
    height 340px
    border-radius 6px
    background #fff

    .iconfont
      position absolute
      top 20px
      right 20px
      color #303133
      font-size 20px
      cursor pointer

    .login_company_title
      margin-bottom 20px
      width 100%
      text-align center

      span
        color rgb(71, 71, 71)
        font-weight 600
        font-size 20px

    .company_list
      margin-bottom 20px
      margin-left 20px
      height 150px

    .login_button
      padding-right 20px
      padding-left 20px

      button
        width 340px
        height 36px
        line-height 0
</style>
